import React from 'react';
import SidebarHeader from 'components/organisms/SidebarHeader';
import SidebarMenu from 'components/organisms/SidebarMenu';
import SidebarFooter from 'components/organisms/SidebarFooter';
import DocumentHistory from 'components/organisms/DocumentHistory';
import { SidebarProps } from 'types/components.types';
import useSidebarStore from 'stores/sidebarStore';

const Sidebar: React.FC<SidebarProps> = ({
  className = '',
  onToggle: _onToggle,
  onNewClassification,
  onLogout,
  isAuthenticated = false,
  userId,
  onDocumentClick
}) => {
  const { isCollapsed, toggle } = useSidebarStore();

  return (
    <div className={`${isCollapsed ? 'w-[72px]' : 'w-[280px]'} bg-white flex flex-col fixed h-screen z-10 transition-all duration-200 ${className}`}>
      <SidebarHeader onToggle={toggle} isCollapsed={isCollapsed} />
      <SidebarMenu onNewClassification={onNewClassification} isCollapsed={isCollapsed} />

      {/* Document History Section - Only show when user is authenticated and userId is available */}
      {isAuthenticated && userId && !isCollapsed && (
        <div className="flex-1 overflow-y-auto border-t border-gray-100 mt-2">
          <DocumentHistory
            userId={userId}
            onDocumentClick={onDocumentClick}
            className="py-2"
          />
        </div>
      )}

      {/* Flexible spacer when history is not shown */}
      {(!isAuthenticated || !userId || isCollapsed) && <div className="flex-grow" />}

      <SidebarFooter
        onLogout={onLogout}
        isAuthenticated={isAuthenticated}
        isCollapsed={isCollapsed}
      />
    </div>
  );
};

export default Sidebar;
